module.exports = __webpack_public_path__ + "img/wizard_first.c9f4986.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wizard_first.svg
// module id = tgl6
// module chunks = 1